import { useLiveQuery } from '@sanity/preview-kit';
import { useEffect } from 'react';

import { useContextMeta, useContextRouting } from '@core/context';
import { useLanguage } from '@core/hook';
import { applyAbTest, formatMetas, getSanityPageRawQuery } from '@core/sanity/utils';
import { ESanityField, SanityPageResponse, SanityRoute } from '@core/type/sanity';

import { PageBuilder } from './PageBuilder';

export const PageBuilderLive = ({
  cms,
  shouldUseVariation,
}: {
  cms: Extract<SanityPageResponse, { body?: { pageBuilder?: unknown } }>;
  shouldUseVariation: boolean;
}) => {
  const { language } = useLanguage();
  const { query, keyRoute } = useContextRouting();
  const { setMeta } = useContextMeta();

  const [_, sanityQuery, params] = getSanityPageRawQuery(keyRoute as SanityRoute, query, language);
  const [data] = useLiveQuery(cms || null, sanityQuery, params);
  const cmsResult = applyAbTest(data, shouldUseVariation);
  const metadata = data?.[ESanityField.METADATA];

  useEffect(() => {
    setMeta(formatMetas(metadata));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata]);

  return <PageBuilder components={cmsResult?.body?.pageBuilder} pageId={cmsResult._id} />;
};
